var React = require('react');

function Youtube (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M14.447 9.16v6.662l5.288-3.36-5.288-3.302zm-1.032 9.59c-.172 0-.344-.043-.499-.13a1.043 1.043 0 0 1-.533-.912V7.292c0-.377.202-.726.53-.91a1.02 1.02 0 0 1 1.044.023l8.27 5.163a1.048 1.048 0 0 1 .007 1.768l-8.27 5.255c-.168.105-.357.159-.55.159zM16.51 2.083c-7.627 0-11.163.638-11.199.644-.779.147-1.787.949-2.11 1.682-.01.023-1.137 2.705-1.137 8.091 0 5.386 1.127 8.067 1.138 8.094.322.73 1.33 1.532 2.111 1.679.034.006 3.57.644 11.177.644h.02c7.607 0 11.142-.638 11.176-.644.782-.147 1.788-.949 2.112-1.683.01-.024 1.138-2.705 1.138-8.09s-1.128-8.068-1.139-8.094c-.323-.73-1.33-1.532-2.112-1.679-.033-.006-3.568-.644-11.175-.644zm0 22.917h-.02c-7.83 0-11.404-.651-11.552-.678-1.463-.275-3.02-1.515-3.624-2.887C1.26 21.314 0 18.383 0 12.5c0-5.882 1.261-8.815 1.314-8.936.604-1.37 2.161-2.61 3.623-2.886C5.087.651 8.66 0 16.49 0c7.851 0 11.423.651 11.57.678 1.463.275 3.02 1.516 3.624 2.886C31.738 3.685 33 6.618 33 12.5c0 5.883-1.262 8.815-1.317 8.935-.603 1.372-2.16 2.612-3.622 2.887-.148.027-3.72.678-11.55.678z"}));
}

Youtube.displayName = "Youtube";

Youtube.defaultProps = {"viewBox":"0 0 33 25"};

module.exports = Youtube;

Youtube.default = Youtube;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/youtube.svg
// module id = 1287
// module chunks = 0